// "Production" enabled environment
// NOT USED AND DO NOT USE
export const environment = {
    production: true,
    hmr: false,
    appConfig: 'appconfig.production.json',
};
